import type { CardId, CardInstance } from "../types/index.js";

export type CreateInstanceInput = {
  nextCardSequence: number;
};

export type CreateInstanceResult = {
  instance: CardInstance;
  nextCardSequence: number;
};

export function createCardInstance(
  input: CreateInstanceInput,
  cardId: CardId,
): CreateInstanceResult {
  const sequence = input.nextCardSequence;
  return {
    instance: {
      instanceId: `c${sequence}`,
      cardId,
    },
    nextCardSequence: sequence + 1,
  };
}

export function createCardInstances(
  input: CreateInstanceInput,
  cardIds: readonly CardId[],
): { instances: CardInstance[]; nextCardSequence: number } {
  let nextCardSequence = input.nextCardSequence;
  const instances: CardInstance[] = [];

  for (const cardId of cardIds) {
    const result = createCardInstance({ nextCardSequence }, cardId);
    instances.push(result.instance);
    nextCardSequence = result.nextCardSequence;
  }

  return { instances, nextCardSequence };
}
